import styled from 'styled-components';
import { NftAvatarBlock as NftAvatarBlockComponent } from 'components/Shared/NftAvatarBlock';
import { NftMedia as NftMediaComponent } from 'components/Shared/NftMedia';
import { NftMediaSkeleton as NftMediaSkeletonComponent } from 'components/Shared/NftMedia/Skeleton';

export const Wrapper = styled.div`
  padding: 0 20px 20px 20px;
  display: flex;
  flex-direction: column;
`;

export const ArrowBox = styled.div`
  display: inline-block;
  padding: 12px;
  border: none;
  height: 40px;
  background: var(--v3-black-1);
  color: var(--v3-text-color);
  border-radius: 64px;
  margin-right: 15px;

  cursor: pointer;

  &:hover {
    transform: scale(1.2, 1.2);
    -webkit-transform: scale(1.2, 1.2);
    -moz-transform: scale(1.2, 1.2);
  }
`;

export const OwnerBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: transparent;
  top: 0;
  z-index: 2;
  position: sticky;
  padding: 20px;
`;

export const HeaderTitle = styled.h3`
  margin: 0;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: var(--v3-text-color);
`;

export const NftMedia = styled(NftMediaComponent)`
  border-radius: 24px;
`;

export const NftMediaSkeleton = styled(NftMediaSkeletonComponent)`
  border-radius: 24px;
`;

export const NftAvatarBlock = styled(NftAvatarBlockComponent)`
  flex: 1;
`;

export const NftTitle = styled.h4`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: var(--v3-text-color);
  margin-bottom: 32px;
`;

export const AvatarsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  margin: 24px 0;
`;

export const BlankSpace = styled.div`
  height: 100px;
`;

export const NftCardPaymentInfoTitle = styled.div`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  margin-top: 40px;
  color: var(--v3-text-color);
`;

export const NftCardPaymentInfoDescription = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  margin-top: 12px;
  color: var(--v3-text-color);
`;

export const NftCardPaymentInfoPrice = styled.div`
  font-weight: 900;
  font-size: 24px;
  line-height: 24px;
  margin-top: 7px;
  color: var(--v3-primary-color);
`;
